import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';

class Step extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onActivate, locked, id } = this.props;
    if (!locked) onActivate(id);
  }

  render() {
    const {
      active, locked, completed, name, id, isClickable,
    } = this.props;

    return (
      <div
        id={`step-${id}`}
        className={classNames({
          step: true,
          nav: true,
          active,
          locked,
          completed,
        })}
      >
        {isClickable && (
          <button type="button" onClick={this.handleClick}>
            {name}
          </button>
        )}
        {!isClickable && <span>{name}</span>}
      </div>
    );
  }
}

Step.displayName = 'Step';

Step.defaultProps = {
  active: false,
  locked: true,
  completed: false,
  onActivate: noop,
  name: '',
  id: '',
  isClickable: false,
};

Step.propTypes = {
  active: PropTypes.bool,
  locked: PropTypes.bool,
  completed: PropTypes.bool,
  onActivate: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  isClickable: PropTypes.bool,
};

export default Step;



// WEBPACK FOOTER //
// ./src/components/steps/Step.js